export default import.meta.ROLLUP_FILE_URL_8aDaF3UHi3M7z0cobu2nDg